export const MenuItems = [
  {
    name: 'Solutions',
    slug: 'solutions',
    subMenu: [
      {
        name: 'Turnkey',
        slug: 'turnkey',
        path: 'solutions#turnkey',
        nestedSubMenu: {
          products: [
            {
              name: 'Sportsbook',
              icon: 'sportsbook',
              slug: 'sportsbook',
              path: '/products/sportsbook',
              description: 'A complete Sportsbook platform with live and pre-match betting.',
            },
            {
              name: 'Casino Suite',
              icon: 'casinoSuite',
              slug: 'casinoSuite',
              path: '/products/casinoSuite',
              description: '7,000 casino games from BetConstruct and other major suppliers.',
            },
            {
              name: 'Virtual Sports',
              icon: 'virtualSports',
              slug: 'virtualSports',
              path: '/products/virtualSports',
              description: 'Real-money betting on various 3D-designed sports.',
            },
            {
              name: 'Backgammon',
              icon: 'backgammon',
              slug: 'backgammon',
              path: '/products/backgammon',
              description: '7 game variations. Multi-platform experience. User-friendly design. Highly-customisable settings.',
            },
            {
              name: 'Live Casino',
              icon: 'liveCasino',
              slug: 'liveCasino',
              path: '/products/liveCasino',
              description: 'A high-quality and competitively priced gateway with new generation famous casino and hybrid games.',
            },
            {
              name: 'Skill Games',
              icon: 'skillGames',
              slug: 'skillGames',
              path: '/products/skillGames',
              description: 'A traditional casino alternative with Chinese Poker, Backgammon, and Belote.',
            },
            {
              name: 'Poker',
              icon: 'poker',
              slug: 'poker',
              path: '/products/poker',
              description: 'Poker games with intuitive design and highly-customisable settings.',
            },
            {
              name: 'Live video streaming',
              icon: 'liveSports',
              slug: 'liveSports',
              path: '/products/liveSports',
              description: 'Exclusive live or on-demand video streaming for players and bookmakers.',
            },
            {
              name: 'Friendship Platform',
              icon: 'friendship',
              slug: 'friendShip',
              path: '/products/friendShip',
              description: 'Real-time quality data and digital content to be booked.',
            },
            {
              name: 'Statistics',
              icon: 'statistics',
              slug: 'statistics',
              path: '/products/statistics',
              description: 'A wide range of sports information based on historical and near-live data\n.',
            },
            {
              name: 'Social Gaming',
              slug: 'socialGaming',
              icon: 'socialGaming',
              path: '/products/socialGaming',
              description: 'Custom-built social games with unforgettable casino experience.',
            },
            {
              name: 'Odds Display',
              slug: 'oddsDisplay',
              icon: 'liveMonitor',
              path: '/products/liveMonitor',
              description: 'All sports events and their markets exclusively displayed in one place.',
            },
            {
              name: 'Self Service Betting Terminal',
              slug: 'terminal',
              icon: 'terminal',
              path: '/products/terminal',
              description: 'C#-technology self-service betting terminal software for your WindowsOS cabinets and hardware.',
            },
            {
              name: 'Betshop Client',
              slug: 'betshopClient',
              icon: 'betShopClient',
              path: '/products/betShopClient',
              description: 'Take bets, pay off bets, register clients, accept deposits and process withdrawal requests.',
            },
            {
              name: 'Pocket Betshop',
              slug: 'pocketBetshop',
              icon: 'betShopPocket',
              path: '/products/betShopPocket',
              description: 'Sortable AndroidOS software to help agents serve players.',
            },
            {
              name: 'Live Scouting Data',
              slug: 'liveScoutData',
              icon: 'liveScoutDataIcon',
              path: '/products/liveScoutData',
              description: 'Live Scouting Data provides fast and reliable live data for popular sports from all over the world.',
            },
            {
              name: 'Betting Games Software',
              slug: 'bettingGames',
              icon: 'bettingGames',
              path: '/products/bettingGames',
              description: 'BetConstruct in-house-developed and 3rd-party games for your iGaming business.',
            },
          ],
          tools: [
            {
              name: 'CRM',
              icon: 'crm',
              slug: 'crm',
              path: '/tools/crm',
              description: 'Run data-driven marketing campaigns, customise your offerings and meet modern challenges in acquisition and retention with this automated marketing and analytics CRM tool.',
            },
            {
              name: 'Affiliate Marketing',
              icon: 'affiliate',
              slug: 'affiliate',
              path: '/tools/affiliate',
              description: 'Easily set up, expand and manage your affiliate network with one of the most complete affiliate creation and management systems available today.',
            },
            {
              name: 'Umbrella',
              icon: 'umbrella',
              slug: 'umbrella',
              path: '/tools/umbrella',
              description: 'An AI-powered risk management solution, designed to detect and manage potential risks.',
            },
            {
              name: 'Agent System',
              icon: 'agentSystem',
              slug: 'agentSystem',
              path: '/tools/agent-system',
              description: 'Expand your player base through a manageable hierarchy of agent networks.',
            },
          ],
          payments: [
            {
              name: 'Payments',
              icon: 'payments',
              slug: 'payments',
              path: '/payments/payments',
              description: 'Set up your own payment method via SpringBME or enable any of the existing ones.',
            },
          ],
        }
      },
      {
        name: 'WhiteLabel',
        slug: 'whiteLabel',
        path: 'solutions#whiteLabel',
        nestedSubMenu: {
          products: [
            {
              name: 'Sportsbook',
              icon: 'sportsbook',
              slug: 'sportsbook',
              path: '/products/sportsbook',
              description: 'A complete Sportsbook platform with live and pre-match betting.',
            },
            {
              name: 'Casino Suite',
              icon: 'casinoSuite',
              slug: 'casinoSuite',
              path: '/products/casinoSuite',
              description: '7,000 casino games from BetConstruct and other major suppliers.',
            },
            {
              name: 'Virtual Sports',
              icon: 'virtualSports',
              slug: 'virtualSports',
              path: '/products/virtualSports',
              description: 'Real-money betting on various 3D-designed sports.',
            },
            {
              name: 'Backgammon',
              icon: 'backgammon',
              slug: 'backgammon',
              path: '/products/backgammon',
              description: '7 game variations. Multi-platform experience. User-friendly design. Highly-customisable settings.',
            },
            {
              name: 'Live Casino',
              icon: 'liveCasino',
              slug: 'liveCasino',
              path: '/products/liveCasino',
              description: 'A high-quality and competitively priced gateway with new generation famous casino and hybrid games.',
            },
            {
              name: 'Skill Games',
              icon: 'skillGames',
              slug: 'skillGames',
              path: '/products/skillGames',
              description: 'A traditional casino alternative with Chinese Poker, Backgammon, and Belote.',
            },
            {
              name: 'Poker',
              icon: 'poker',
              slug: 'poker',
              path: '/products/poker',
              description: 'Poker games with intuitive design and highly-customisable settings.',
            },
            {
              name: 'Live video streaming',
              icon: 'liveSports',
              slug: 'liveSports',
              path: '/products/liveSports',
              description: 'Exclusive live or on-demand video streaming for players and bookmakers.',
            },
            {
              name: 'Friendship Platform',
              icon: 'friendship',
              slug: 'friendShip',
              path: '/products/friendShip',
              description: 'Real-time quality data and digital content to be booked.',
            },
            {
              name: 'Statistics',
              icon: 'statistics',
              slug: 'statistics',
              path: '/products/statistics',
              description: 'A wide range of sports information based on historical and near-live data\n.',
            },
            {
              name: 'Social Gaming',
              slug: 'socialGaming',
              icon: 'socialGaming',
              path: '/products/socialGaming',
              description: 'Custom-built social games with unforgettable casino experience.',
            },
            {
              name: 'Live Scouting Data',
              slug: 'liveScoutData',
              icon: 'liveScoutDataIcon',
              path: '/products/liveScoutData',
              description: 'Live Scouting Data provides fast and reliable live data for popular sports from all over the world.',
            },
            {
              name: 'Betting Games Software',
              slug: 'bettingGames',
              icon: 'bettingGames',
              path: '/products/bettingGames',
              description: 'BetConstruct in-house-developed and 3rd-party games for your iGaming business.',
            },
          ],
          tools: [
            {
              name: 'CRM',
              icon: 'crm',
              slug: 'crm',
              path: '/tools/crm',
              description: 'Run data-driven marketing campaigns, customise your offerings and meet modern challenges in acquisition and retention with this automated marketing and analytics CRM tool.',
            },
            {
              name: 'Affiliate Marketing',
              icon: 'affiliate',
              slug: 'affiliate',
              path: '/tools/affiliate',
              description: 'Easily set up, expand and manage your affiliate network with one of the most complete affiliate creation and management systems available today.',
            },
            {
              name: 'Umbrella',
              icon: 'umbrella',
              slug: 'umbrella',
              path: '/tools/umbrella',
              description: 'An AI-powered risk management solution, designed to detect and manage potential risks.',
            },
            {
              name: 'Agent System',
              icon: 'agentSystem',
              slug: 'agentSystem',
              path: '/tools/agent-system',
              description: 'Expand your player base through a manageable hierarchy of agent networks.',
            },
          ],
        },
      },
      {
        name: 'Odds Feed',
        slug: 'oddsFeed',
        path: 'solutions#oddsFeed',
        nestedSubMenu: {
          products: [
            {
              name: 'Friendship Platform',
              icon: 'friendship',
              slug: 'friendShip',
              path: '/products/friendShip',
              description: 'Real-time quality data and digital content to be booked',
            },
            {
              name: 'Odds Feed',
              icon: 'oddsFeed',
              slug: 'oddsFeed',
              path: '/products/oddsFeed',
              description: `Let your business benefit from our accurate and efficient sports betting data.`,
            },
          ],
        },
      },
      {
        name: 'Casino Api',
        slug: 'casinoApi',
        path: 'solutions#casinoApi',
        nestedSubMenu: {
          products: [
            {
              name: 'Casino Suite',
              icon: 'casinoSuite',
              slug: 'casinoSuite',
              path: '/products/casinoSuite',
              description: '7,000 casino games from BetConstruct and other major suppliers.',
            },
            {
              name: 'Virtual Sports',
              icon: 'virtualSports',
              slug: 'virtualSports',
              path: '/products/virtualSports',
              description: 'Real-money betting on various 3D-designed sports.',
            },
            {
              name: 'Backgammon',
              icon: 'backgammon',
              slug: 'backgammon',
              path: '/products/backgammon',
              description: '7 game variations. Multi-platform experience. User-friendly design. Highly-customisable settings.',
            },
            {
              name: 'Live Casino',
              icon: 'liveCasino',
              slug: 'liveCasino',
              path: '/products/liveCasino',
              description: 'A high-quality and competitively priced gateway with new generation famous casino and hybrid games.',
            },
            {
              name: 'Skill Games',
              icon: 'skillGames',
              slug: 'skillGames',
              path: '/products/skillGames',
              description: 'A traditional casino alternative with Chinese Poker, Backgammon, and Belote.',
            },
            {
              name: 'Poker',
              icon: 'poker',
              slug: 'poker',
              path: '/products/poker',
              description: 'Poker games with intuitive design and highly-customisable settings.',
            },
            {
              name: 'Social Gaming',
              slug: 'socialGaming',
              icon: 'socialGaming',
              path: '/products/socialGaming',
              description: 'Custom-built social games with unforgettable casino experience.',
            },
            {
              name: 'Odds Display',
              slug: 'oddsDisplay',
              icon: 'liveMonitor',
              path: '/products/liveMonitor',
              description: 'All sports events and their markets exclusively displayed in one place',
            },
            {
              name: 'Self Service Betting Terminal',
              slug: 'terminal',
              icon: 'terminal',
              path: '/products/terminal',
              description: 'C#-technology self-service betting terminal software for your WindowsOS cabinets and hardware.',
            },
            {
              name: 'Betshop Client',
              slug: 'betshopClient',
              icon: 'betShopClient',
              path: '/products/betShopClient',
              description: 'Take bets, pay off bets, register clients, accept deposits and process withdrawal requests.',
            },
            {
              name: 'Pocket Betshop',
              slug: 'pocketBetshop',
              icon: 'betShopPocket',
              path: '/products/betShopPocket',
              description: 'Sortable AndroidOS software to help agents serve players.',
            },
            {
              name: 'Betting Games Software',
              slug: 'bettingGames',
              icon: 'bettingGames',
              path: '/products/bettingGames',
              description: 'BetConstruct in-house-developed and 3rd-party games for your iGaming business.',
            },
          ],
        },
      },
      {
        name: 'Sportsbook Api',
        slug: 'sportsbookApi',
        path: 'solutions#sportsbookApi',
        nestedSubMenu: {
          products: [
            {
              name: 'Sportsbook',
              icon: 'sportsbook',
              slug: 'sportsbook',
              path: '/products/sportsbook',
              description: 'A complete Sportsbook platform with live and pre-match betting.',
            },
            {
              name: 'Virtual Sports',
              icon: 'virtualSports',
              slug: 'virtualSports',
              path: '/products/virtualSports',
              description: 'Real-money betting on various 3D-designed sports.',
            },
            {
              name: 'Live video streaming',
              icon: 'liveSports',
              slug: 'liveSports',
              path: '/products/liveSports',
              description: 'Exclusive live or on-demand video streaming for players and bookmakers.',
            },
            {
              name: 'Friendship Platform',
              icon: 'friendship',
              slug: 'friendShip',
              path: '/products/friendShip',
              description: 'Real-time quality data and digital content to be booked.',
            },
            {
              name: 'Statistics',
              icon: 'statistics',
              slug: 'statistics',
              path: '/products/statistics',
              description: 'A wide range of sports information based on historical and near-live data\n.',
            },
            {
              name: 'Social Gaming',
              slug: 'socialGaming',
              icon: 'socialGaming',
              path: '/products/socialGaming',
              description: 'Custom-built social games with unforgettable casino experience.',
            },
            {
              name: 'Odds Display',
              slug: 'oddsDisplay',
              icon: 'liveMonitor',
              path: '/products/liveMonitor',
              description: 'All sports events and their markets exclusively displayed in one place',
            },
            {
              name: 'Self Service Betting Terminal',
              slug: 'terminal',
              icon: 'terminal',
              path: '/products/terminal',
              description: 'C#-technology self-service betting terminal software for your WindowsOS cabinets and hardware.',
            },
            {
              name: 'Betshop Client',
              slug: 'betshopClient',
              icon: 'betShopClient',
              path: '/products/betShopClient',
              description: 'Take bets, pay off bets, register clients, accept deposits and process withdrawal requests.',
            },
            {
              name: 'Pocket Betshop',
              slug: 'pocketBetshop',
              icon: 'betShopPocket',
              path: '/products/betShopPocket',
              description: 'Sortable AndroidOS software to help agents serve players.',
            },
            {
              name: 'Live Scouting Data',
              slug: 'liveScoutData',
              icon: 'liveScoutDataIcon',
              path: '/products/liveScoutData',
              description: 'Live Scouting Data provides fast and reliable live data for popular sports from all over the world.',
            },
          ],
        },
      },
    ],
  },
  {
    name: 'Services',
    slug: 'services',
    path: 'services',
  },
  {
    name: 'Marketplace',
    slug: 'marketplace',
    path: 'marketplace',
  },
  /*{
    name: 'Partnership',
    slug: 'partnership',
    path: 'partnership',
  },*/
];
